// ======================================================================
// File Name       : ScoringReportConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const REPORT_LIST_MODE = {
  TOP: 'top',
  GET: 'get',
  CORRECTION: 'correction',
  APPROVAL: 'approval',
  REMAND: 'remand',
  COMPULSORY_COLLECTION: 'collection',
  WITHDRAWAL: 'withdrawal',
};

export const REPORT_STATUS_ID = {
  NOT_SUBMITTED: 0,
  SUBMITTED: 1,
  CHECKING: 2,
  REMAND: 3,
  PENDING_APPROVAL: 4,
  APPPROVED: 5,
  RESULT_RETURN: 6,
};

export const REPORT_STATUS_NAME = {
  NOT_SUBMITTED: '未提出',
  SUBMITTED: '提出済み',
  CHECKING: '添削中',
  REMAND: '差し戻し',
  PENDING_APPROVAL: '承認待ち',
  APPPROVED: '承認済み',
  RESULT_RETURN: '結果返却済み',
};

export const REPORT_OPERATION_TYPE = {
  APPROVAL: 0,
  REMAND: 1,
  COLLECT: 2,
  DISTRIBUTION: 3,
  ACQUISITION: 4,
  WITHDRAWAL: 5,
  FINISH: 6,
  SAVE: 7,
};

export const SCORING_REPORT_SEARCH_TYPE = {
  SUBMITTER: 'submitter',
  CHECKER: 'checker',
  NORMAL: 'normal',
};

export const Label_Approval = '承認';
export const Label_Remand = '差し戻し';
export const Label_Collect = '強制回収';
export const Label_Correct = '添削';
export const Label_WithDrawal = '取り下げ';
export const Label_Reason = '差し戻し理由';
export const Label_Finish = '添削完了';
export const Label_Save = '保存・成績更新';
export const Name_Denial_Reason = 'denialReason';

export const ANSWER_JUDGE_RESULT = {
  CORRECT: 0,
  INCORRECT: 1,
  NOT_ANSWER: 2,
  PASS: 3,
  INTERRUPTION: 4,
  BIG_QUESTION: 99,
};

export const USER_HISTORY_LIST_RESULT_DEFAULT_COLUMN = 10;

// #7404 START
export const SCORE_FORM_SCORE = 2;
export const MARK_RULE_ABSOLUTE_SCORE = 0;
export const SANKAKU_JUDGE_USE_SET_USE = 1;
export const SANKAKU_USE_DISTINCT_USE = 1;
// #7404 END
